import styled from 'styled-components';
import Search from '../../../Search';

const StyledTableFilters = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledTableFiltersSearch = styled(Search)`
  min-height: 40px;
  max-width: 264px;
  min-width: 150px;
  width: 100%;
`;

const StyledTableFiltersElements = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow-x: hidden;

  .ant-select {
    width: 145px;
    .ant-select-selector {
      min-height: 40px;
    }
  }

  .ant-picker.ant-picker-range {
    height: 40px;
    max-width: 250px;
  }

  .table-filters-right-side-content {
    margin-left: 62px;
  }
`;

export {
  StyledTableFiltersSearch,
  StyledTableFilters,
  StyledTableFiltersElements,
};
